import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/translation.json';
import nl from './locales/nl/translation.json';

const resources = {
  en: { translation: en },
  nl: { translation: nl },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'nl',
    fallbackLng: 'nl',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

// Update document title when language changes
i18n.on('languageChanged', (lng) => {
  document.title = i18n.t('site_title');
  document.documentElement.lang = lng;
});

// Set initial title
document.title = i18n.t('site_title');

export default i18n; 